import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const NurseDashboard = () => {
  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, mt: 5 }}>
        <Typography variant="h4" gutterBottom>
          Nurse Dashboard
        </Typography>

        <Box mt={2}>
          <Typography variant="body1">
            Welcome, Nurse! You can view your assigned visits, update medical notes, and manage client care plans.
          </Typography>

          {/* Future widgets or cards */}
          {/* <VisitList /> */}
          {/* <CareTasks /> */}
        </Box>
      </Paper>
    </Container>
  );
};

export default NurseDashboard;
